import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { localRawStorage } from '@/services/storage/storage.service';

export type ThemeMode = 'light' | 'dark' | 'system';

interface ThemeState {
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      mode: 'system',
      setMode: (mode) => {
        set({ mode });
      },
    }),
    { name: 'quiz_admin.theme', storage: createJSONStorage(() => localRawStorage) },
  ),
);
